import useSWR from "swr";
import { api } from '@portal/arq-portal-core';

const alertasKey = "marquesina";
const alertasService = "/be/marquesinausuario/";
const alertasConfig = { dedupingInterval: 60000 };

const useMarquesina = (userid:string) =>  useSWR([alertasKey, userid], ()=>api.post(alertasService,{Entrada:{}}), alertasConfig);

export default useMarquesina;